import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LabelModel } from 'src/app/models/api/common';
import { AddLabelsActionDefinitionModel as AddLabelActionDefinitionModel } from 'src/app/models/api/playbooks/actions/addLabelProperties';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';
import { ISelectOption } from 'src/app/models/selectOptions';
import { NotificationsService } from 'src/app/services/infra/notifications/notifications.service';
import { StoreService } from 'src/app/services/infra/store/store.service';

@Component({
  selector: 'app-add-label-action',
  templateUrl: './add-label-action.component.html',
  styleUrls: ['./add-label-action.component.scss'],
})
export class AddLabelActionComponent implements OnInit {
  @Input() public fg: UntypedFormGroup;
  @Input() public playbooksActionInput: PlaybooksActionDefinitionInput;
  @Input() public triggerType: TriggerTypes;

  public checkedLabelIds: string[] = [];
  public description = '';

  public searchLabelNameValues: string[] = [];
  public allLabels: LabelModel[] = [];
  public searchLabelShown: ISelectOption[] = [];
  public searchLabelShownHeight = '0px';

  private _addLabelActionDefinitionModel?: AddLabelActionDefinitionModel;

  constructor(
    private readonly _store: StoreService,
    private readonly _notificationService: NotificationsService
  ) {}

  ngOnInit(): void {
    this._store.labels$.subscribe((labels: LabelModel[]) => {
      this._initLabelNameFilter(labels);
    });
    if (this.playbooksActionInput.actionDefinitionProperties) {
      this._addLabelActionDefinitionModel = this.playbooksActionInput
        .actionDefinitionProperties as AddLabelActionDefinitionModel;
      this.checkedLabelIds = this._addLabelActionDefinitionModel.labelIds;
      this._removeDeletedLabelIds();
      this.description = this._addLabelActionDefinitionModel.description;
    }
    this.fg.addControl('labelIds', new UntypedFormControl(this.checkedLabelIds, [Validators.required]));
    this.fg.addControl('description', new UntypedFormControl(this.description.trim()));
  }

  public labelNameSubmitted(labels: string[] = []): void {
    this.searchLabelShown = [];
    labels.forEach((label: string) => {
      const labelModel = this.allLabels.find((labelExist: LabelModel) => labelExist.displayName === label);
      if (labelModel) {
        this.searchLabelShown.push({
          id: labelModel.id,
          value: labelModel.displayName,
          displayName: labelModel.displayName,
        } as ISelectOption);
      }
    });
    this.searchLabelShownHeight = this._getSearchLabelShownHeight();
  }

  public onLabelSelect(labelId: string) {
    const index = this.checkedLabelIds.indexOf(labelId);
    if (index !== -1) {
      this.checkedLabelIds.splice(index, 1);
    } else {
      this.checkedLabelIds.push(labelId);
    }
    this.fg.controls['labelIds'].setValue(this.checkedLabelIds);
  }

  private _initLabelNameFilter(labels: LabelModel[]) {
    labels.forEach((label: LabelModel) => {
      if (this.allLabels.find((labelExist: LabelModel) => labelExist.id === label.id)) return;
      this.allLabels.push(label);
      this.searchLabelNameValues.push(label.displayName);
    });
    this.labelNameSubmitted(this.searchLabelNameValues);
  }

  private _getSearchLabelShownHeight(): string {
    const height = Math.min(this.searchLabelShown.length * 40, 160);
    return height + 'px';
  }

  private _removeDeletedLabelIds() {
    const existingLabelIds = this.allLabels.map((label) => label.id).filter((id) => this.checkedLabelIds.includes(id));
    if (existingLabelIds.length !== this.checkedLabelIds.length) {
      this.checkedLabelIds = existingLabelIds;
      this._notificationService.info(
        'One or more labels were automatically removed, because they were deleted from Zenity. Validate action relevance and save changes'
      );
    }
  }
}
